import { render, staticRenderFns } from "./EdsCard.vue?vue&type=template&id=4a99d5b4&scoped=true&"
import script from "./EdsCard.vue?vue&type=script&lang=js&"
export * from "./EdsCard.vue?vue&type=script&lang=js&"
import style0 from "./EdsCard.vue?vue&type=style&index=0&id=4a99d5b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99d5b4",
  null
  
)

export default component.exports